import { Flex, Shimmer, Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"
import styled from "styled-components"

import { to_currency } from "helpers/number"

const TotalRow = styled(Flex).attrs({
  alignItems: "center",
  justifyContent: "space-between",
  lineHeight: "20px",
  mb: 2,
})``

const TotalText = styled(Typography).attrs({
  as: "span",
  fontSize: "18px",
  fontWeight: "700",
})``

const TotalItemPrice = ({ loading, totalItemPrice }) => (
  <TotalRow>
    <TotalText>Subtotal</TotalText>
    {loading ? (
      <Shimmer height="20px" width="45px" />
    ) : (
      <TotalText textAlign="right">{to_currency(totalItemPrice)}</TotalText>
    )}
  </TotalRow>
)

TotalItemPrice.propTypes = {
  loading: PropTypes.bool,
  totalItemPrice: PropTypes.number,
}

const mapStateToProps = (state) => {
  const productPrice = state.wizardUI.currentPricing.price_to_display
  const boxPrice = state.choices.box ? state.choices.box.price : 0
  // TODO: Add product addon price

  const totalItemPrice = productPrice + boxPrice

  const prefStore = state.wizardUI.prefStore
  const wizardLoading = state.wizard.loading

  return {
    loading: !prefStore || !!wizardLoading,
    totalItemPrice,
  }
}

export default connect(mapStateToProps)(TotalItemPrice)
